import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../interceptors/authErrorInterceptor';
import { EcoTaxRequest, EcoTaxResponse } from './ecoTaxService.types';
import axiosBaseQuery from '../axiosBaseQuery';
import { adapter } from '../adapters';

export const ecoTaxService = createApi({
  reducerPath: 'ecoTax',
  baseQuery: baseQueryWithReauth(axiosBaseQuery(adapter)),
  endpoints: (builder) => ({
    getEcoTax: builder.mutation<EcoTaxResponse[], EcoTaxRequest>({
      query: (body) => ({
        url: '/ecotax:query',
        method: 'post',
        body,
      }),
    }),
  }),
});

export const { useGetEcoTaxMutation } = ecoTaxService;
